
import React, { useState, useEffect } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Dropdown from 'react-bootstrap/Dropdown';
import './categorydiscount.scss'
const Categorydiscount = () => {

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>

      <section className='categorydiscountssss'>
        <div className="innercatgorydiscount">

          <h1 className="headercoupanmain">
            Category Based Discount
          </h1>
          <button className="innerbtncatgorydiscount">
            Add Discount
          </button>
        </div>

        <div className="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">On/Off</th>
                <th scope="col"> Category Name</th>
                <th scope="col"> Upload Date</th>
                <th scope="col">Expired On</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>

              <>
                <tr>
                  <td>
                    <div className="switch-input">
                      <input
                        class="tgl tgl-ios"
                        id={"toggle2"}
                        type="checkbox"


                      />
                      <label
                        class="tgl-btn"
                        htmlFor="toggle2"
                      ></label>
                    </div>
                  </td>


                  <td className="innersectd">
                    FnVs


                  </td>
                  <td>
                    Nov 25, 2021
                  </td>
                  <td>
                    Nov 25, 2021
                  </td>
                  <td>
                    <span className="innerfourthtd">
                      Rs200 Fixed
                    </span>
                    {/* <span className="innerfourthtdgreen">
                                            15%
                                        </span> */}
                  </td>
                  <td>
                    <a
                      onClick={() => {
                        setShow(true);


                      }}
                    >
                      <img
                        src="\users-assets\edit-icon.svg"
                        alt="img"
                        className="img-fluid mr-2"
                      />
                    </a>
                    <a
                    // onClick={() => {
                    //     setShow1(
                    //         true
                    //     );

                    // }}
                    >
                      <img
                        src="\users-assets\trash-icon.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </a>
                  </td>





                </tr>
                <tr>
                  <td>
                    <div className="switch-input">
                      <input
                        class="tgl tgl-ios"
                        id={"toggle1"}
                        type="checkbox"


                      />
                      <label
                        class="tgl-btn"
                        htmlFor="toggle1"
                      ></label>
                    </div>
                  </td>


                  <td className="innersectd">
                    K&Ns


                  </td>
                  <td>
                    Nov 25, 2021
                  </td>
                  <td>
                    Nov 25, 2021
                  </td>
                  <td>

                    {/* <span className="innerfourthtdgreen">
                                            15%
                                        </span> */}
                    <span className="innerfourthtdred">
                      Expired
                    </span>
                  </td>
                  <td>
                    <a
                      onClick={() => {
                        setShow(true);


                      }}
                    >
                      <img
                        src="\users-assets\edit-icon.svg"
                        alt="img"
                        className="img-fluid mr-2"
                      />
                    </a>
                    <a
                    // onClick={() => {
                    //     setShow1(
                    //         true
                    //     );

                    // }}
                    >
                      <img
                        src="\users-assets\trash-icon.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </a>
                  </td>















                </tr>
              </>



            </tbody>
          </table>
        </div>
      </section>

      <Offcanvas
        show={show}
        onHide={handleClose}
        className="dicountmainbanner"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Create Coupon</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="bannerss">
            <h4>Code</h4>
            <div className="filedinputssss">
              <div className="prntmaindrop">

                <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <div className="inputrel">

                      <input
                        type="text"
                        placeholder="Title"


                      />
                      <svg className="svgabsol" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M9.58317 17.4998C13.9554 17.4998 17.4998 13.9554 17.4998 9.58317C17.4998 5.21092 13.9554 1.6665 9.58317 1.6665C5.21092 1.6665 1.6665 5.21092 1.6665 9.58317C1.6665 13.9554 5.21092 17.4998 9.58317 17.4998Z" stroke="#009DE0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M18.3332 18.3332L16.6665 16.6665" stroke="#009DE0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1"> <h3 className="dropitemh3" >Fixed</h3></Dropdown.Item>
                    <Dropdown.Item href="#/action-2"> <h3 className="dropitemhsecnd">Percentage</h3></Dropdown.Item>

                  </Dropdown.Menu>
                </Dropdown>
              </div>

            </div>
            <h4>Discount</h4>
            <div className="filedinput">
              <div className="prntmaindrop">

                <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <h3 className="droptoggleh3">Type</h3>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1"> <h3 className="dropitemh3" >Fixed</h3></Dropdown.Item>
                    <Dropdown.Item href="#/action-2"> <h3 className="dropitemhsecnd">Percentage</h3></Dropdown.Item>

                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <input
                type="text"
                placeholder="Discount"


              />











            </div>
            <h4>Expired On</h4>
            <input
              type="text"
              placeholder="DD/MM/YY"


            />
            <div className="buttonss">
              <button className="btn-1" >
                Cancel
              </button>
              <button className="btn-1 btn-2 btnactive" >
                Schedule
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default Categorydiscount